// extracted by mini-css-extract-plugin
module.exports = {"section":"Content_section__9vtPy"};